import PT from 'prop-types';
import React from 'react';

import { Icon } from '~/eds/src/components/Icon/Icon';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';

function Section({ children, description, icon, id, title }) {
  return (
    <FlexLayout flexDirection="column" space={6}>
      <FlexLayout flexDirection="column" space={2}>
        <FlexLayout alignItems="center" space={2} id={id}>
          {icon && <Icon icon={icon} color="status.active" />}
          <Text color="gray-900" variant="l-dense-bold">
            {title}
          </Text>
        </FlexLayout>
        {description && (
          <Text color="gray-600" variant="xs-dense-medium">
            {description}
          </Text>
        )}
      </FlexLayout>
      {children}
    </FlexLayout>
  );
}

Section.propTypes = {
  id: PT.string,
  children: PT.node,
  description: PT.oneOfType([PT.string, PT.node]),
  icon: PT.string,
  title: PT.string.isRequired,
};

export default Section;
